(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/slim-banner/assets/javascripts/slim-banner.js') >= 0) return;  svs.modules.push('/widgets/slim-banner/assets/javascripts/slim-banner.js'); "use strict";


(function (svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.slim_banner = svs.widget.slim_banner || {};
  svs.widget.slim_banner.init = svs.content.bannerTypeSlimbanner.init;
})(svs);
 })(window);